import React from 'react';
import { Link } from 'react-router-dom';
import Icon from 'components/blocks/Icon/Icon';
import './QuickActions.scss';

interface QuickAction {
  id: string;
  icon: string;
  title: string;
  sub: string;
  route: string;
}

const quickActions: QuickAction[] = [
  {
    id: 'citas',
    icon: 'calendar',
    title: 'Mis citas',
    sub: 'Consulta y gestiona tus próximas citas',
    route: '/mis-citas',
  },
  {
    id: 'notificaciones',
    icon: 'bell',
    title: 'Notificaciones',
    sub: 'Revisa los formularios y avisos pendientes',
    route: '/notificaciones',
  },
  {
    id: 'comunicaciones',
    icon: 'message',
    title: 'Comunicaciones',
    sub: 'Contacta con tu gestor asignado',
    route: '/comunicaciones',
  },
  {
    id: 'documentos',
    icon: 'file-text',
    title: 'Historial',
    sub: 'Accede a tu historial de prestaciones',
    route: '/historial',
  },
];

interface QuickActionsProps {
  className?: string;
}

const QuickActions: React.FC<QuickActionsProps> = ({ className }) => {
  return (
    <section className={`qa-section${className ? ` ${className}` : ''}`}>
      <div className="container">
        <div className="section__head">
          <div>
            <h2 className='title-qa' style={{fontSize:"38px"}}>Acciones rápidas</h2>
            <p className="section__sub">Lo que más usas, a un clic</p>
          </div>
        </div>
        <div className="qa-grid">
          {quickActions.map(qa => (
            <Link
              key={qa.id}
              className="qa-tile reveal is-in"
              to={qa.route}
            >
              <div className="qa-tile__icon">
                <Icon name={qa.icon} size={26} />
              </div>
              <div>
                <div className="qa-tile__title">{qa.title}</div>
                <div className="qa-tile__sub">{qa.sub}</div>
              </div>
              <span className="qa-tile__arrow">
                <Icon name="arrow-right" size={20} />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default QuickActions;
